import { useState } from 'react'

const useSearchModal = () => {
  const [modalOpen, setModalOpen] = useState(false)

  return { modalOpen, setModalOpen }
}

export default useSearchModal
